import { css } from 'styled-components';

const Content = css`
  width: 100%;
  max-width: 1360px;
`;

export default Content;
